<app-breadcrumb [master]="'Narzędzia'" [parentName]="'Baza wiedzy'" [name]="'Lista'"></app-breadcrumb>
<div class="file-manager-list-container">
  <div fxLayout="row">
    <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="file-manager-list-filters">

    </form>
  </div>


  <div fxLayout="row" fxLayoutGap="15px" style="margin-bottom: 15px">
    <button *ngIf="idValue" (click)="back()"  class="report-button" mat-raised-button color="primary">
      <mat-icon>arrow_back</mat-icon>
      <span> Powrót </span></button>
    <button *ngIf="(userPermissions | async)?.file_manager.create" (click)="addFile()"  class="report-button" mat-raised-button color="primary">
      <mat-icon>note_add</mat-icon>
      <span> Dodaj plik </span></button>
    <button *ngIf="(userPermissions | async)?.file_manager.create" (click)="addCatalog()"  class="report-button" mat-raised-button color="primary">
      <mat-icon>create_new_folder</mat-icon>
      <span> Dodaj folder </span></button>
  </div>

  <div fxLayout="column">


    <table mat-table [dataSource]="fileManager"
           cdkDropList
           [cdkDropListData]="fileManager"
           (cdkDropListDropped)="drop($event)">

            <ng-container matColumnDef="fileName">
              <th mat-header-cell *matHeaderCellDef> Nazwa</th>
              <td mat-cell *matCellDef="let element">
                <a class="default-link" *ngIf="element.type === 'Folder'"
                   [routerLink]="['/serwis-plikow/', element.uuid]" (click)="idValue = element.uuid; this.loadListData()">{{ element.name}}</a>
                  <span *ngIf="element.type !== 'Folder'">{{ element.name}}</span>
              </td>
            </ng-container>
      <ng-container matColumnDef="img">
        <th mat-header-cell *matHeaderCellDef> </th>
        <td mat-cell *matCellDef="let element">
            <img  *ngIf="element.folderIcon"  [src]="getImg(element)" width="32" height="32" style="justify-items: center"  >
        </td>
      </ng-container>
          <ng-container matColumnDef="typ">
            <th mat-header-cell *matHeaderCellDef> Rodzaj</th>
            <td mat-cell *matCellDef="let element">
              {{ element.type }}
            </td>
          </ng-container>

      <ng-container matColumnDef="public">
        <th mat-header-cell *matHeaderCellDef> Wewnętrzny</th>
        <td mat-cell *matCellDef="let element">
          <button *ngIf="element.public"  mat-icon-button><mat-icon class="positive-icon">check_circle</mat-icon></button>
          <button *ngIf="!element.public" mat-icon-button><mat-icon class="negative-icon">cancel</mat-icon></button>
        </td>
      </ng-container>

      <ng-container matColumnDef="cratedAt">
        <th mat-header-cell *matHeaderCellDef> Data utworzenia</th>
        <td mat-cell *matCellDef="let element">
          {{element.createdAt | date:'y-MM-dd'}}
        </td>
      </ng-container>

      <ng-container matColumnDef="download">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <button *ngIf="element.type === 'Plik' " [disabled]="!(userPermissions | async).file_manager.read " (click)="download(element.uuid)"  mat-icon-button color="accent"><mat-icon>download</mat-icon></button>
          <button *ngIf="element.type === 'Folder' && ((userPermissions | async).file_manager.admin_root ||( element.userId === profile.userId  && (userPermissions | async).file_manager.delete))"  [disabled]="!(userPermissions | async).file_manager.admin_root && element.userId !== profile.userId"  (click)="deleteCatalog(element.uuid)"  mat-icon-button color="warn"><mat-icon>delete</mat-icon></button>
          <button *ngIf="element.type === 'Plik' && ((userPermissions | async).file_manager.admin_root ||( element.userId === profile.userId  && (userPermissions | async).file_manager.delete)) " [disabled]="!(userPermissions | async).file_manager.admin_root && element.userId !== profile.userId"  (click)="deleteFile(element.uuid)"  mat-icon-button color="warn"><mat-icon>delete</mat-icon></button>
          <button *ngIf="element.type === 'Plik' && element.public " [disabled]="!(userPermissions | async).file_manager.read " (click)="getLink(element)"  mat-icon-button ><mat-icon>arrow_outward</mat-icon></button>
          <button *ngIf="element.type === 'Plik'  && ((userPermissions | async).file_manager.admin_root ||( element.userId === profile.userId  && (userPermissions | async).file_manager.write))"  [disabled]="!(userPermissions | async).file_manager.admin_root && element.userId !== profile.userId" (click)="editFile(element)"  mat-icon-button ><mat-icon>edit</mat-icon></button>
          <button *ngIf="element.type === 'Folder' && ((userPermissions | async).file_manager.admin_root ||( element.userId === profile.userId  && (userPermissions | async).file_manager.write))"  [disabled]="!(userPermissions | async).file_manager.admin_root && element.userId !== profile.userId"  (click)="editCatalog(element)"  mat-icon-button ><mat-icon>edit</mat-icon></button>


        </td>
      </ng-container>

      <ng-container matColumnDef="tag">
        <th mat-header-cell *matHeaderCellDef> Tag </th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngFor="let tag of element.tag?.split(',')">
            {{tag}} <br>
          </ng-container>
        </td>
      </ng-container>


      <ng-container matColumnDef="createdBy">
        <th mat-header-cell *matHeaderCellDef > Użytkownik</th>
        <td mat-cell *matCellDef="let element" >
          {{element.createdBy }}
        </td>
      </ng-container>



      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" cdkDrag [cdkDragData]="row"></tr>
    </table>

    <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
  </div>
</div>


